import { construirFecha } from "../utils/ConstruirFecha";
import { esFechaValida } from "../utils/EsFechaValida";
import { validarFechaNoFutura } from "../utils/ValidarFechaNoFutura";

export function validarRecibos(recibo) {
  const errors = [];

  if (
    !recibo.FechaDePago.dia ||
    !recibo.FechaDePago.mes ||
    !recibo.FechaDePago.ano
  ) {
    errors.push("Falta la fecha de pago");
  } else {
    if (
      !esFechaValida(
        recibo.FechaDePago.dia,
        recibo.FechaDePago.mes,
        recibo.FechaDePago.ano,
      )
    ) {
      errors.push("fecha de pago invalida.");
    } else {
      const fecha = construirFecha(
        recibo.FechaDePago.dia,
        recibo.FechaDePago.mes,
        recibo.FechaDePago.ano,
      );
      if (!validarFechaNoFutura(fecha)) {
        errors.push("La fecha de pago no puede ser futura");
      }
    }
  }

  if (!recibo.numRecibo.ptoVta) {
    errors.push("Falta el punto de venta");
  }

  if (!recibo.idCliente) errors.push("El ID del cliente es obligatorio");

  if (!recibo.idTipoNegocio)
    errors.push("El ID del tipo de negocio es obligatorio");

  return {
    isValid: errors.length === 0,
    errors,
  };
}
